export const ELLA_MIC_CONSENT_COPY =
  "Ella can take requests by voice. Maestro needs the microphone only while you're speaking to Ella; it's never on otherwise.";

export const ELLA_MIC_CONSENT_KEY = 'maestro_ella_mic_consent';

export function hasEllaMicConsent() {
  try {
    return localStorage.getItem(ELLA_MIC_CONSENT_KEY) === '1';
  } catch {
    return false;
  }
}

export function grantEllaMicConsent() {
  try {
    localStorage.setItem(ELLA_MIC_CONSENT_KEY, '1');
  } catch {}
}

export async function notifyConnectorMicConsent() {
  try {
    const invoke = window.__TAURI__?.core?.invoke || window.__TAURI__?.invoke;
    if (typeof invoke === 'function') {
      await invoke('enable_microphone_after_consent');
    }
  } catch {}
}

export async function acceptEllaMicConsent() {
  grantEllaMicConsent();
  await notifyConnectorMicConsent();
}
